import Discover from './modules/discover';
import ArticleEngagement from './modules/article-engagement';

const modules = {
  Discover,
  ArticleEngagement
};

var elements = document.querySelectorAll('.js-modules');
if (elements.length > 0) {
  var options = JSON.parse(elements[0].text || elements[0].textContent);
  options.modules.forEach((module) => {
    if (modules[module.name]) {
      new modules[module.name](module.options);
    }
  });
}
